import PaginationFootballProperties from "../../../Football/Models/Pagination/PaginationFootballProperties";
import FiltersMetaModel from "./FiltersMetaModel";

export default class TemplateMeta {
    public pagination: PaginationFootballProperties = new PaginationFootballProperties();
    public filters: FiltersMetaModel = new FiltersMetaModel();
}